import { writable } from 'svelte/store';
export const currentUser = writable(null);
export const id = () => '_' + Math.random().toString(36).substr(2, 9);

export const findSimPDPGrid = {
	name: 'Find Similar Product Details',
	id: id(),
	page_type: 'productDetails',
	mobile: {
		items: [
			{
				type: 'collection',
				size: 1,
				title: 'Other Products You May Like',
				collection: 'find_similar',
				fallback: 'top_viewed',
				fallback_title: 'Top Viewed',
				num_products: 12,
				device: 'mobile',
				id: id()
			}
		]
	},
	desktop: {
		items: [
			{
				type: 'collection',
				size: 4,
				title: 'Other Products You May Like',
				collection: 'find_similar',
				fallback: 'top_viewed',
				fallback_title: 'Top Viewed',
				num_products: 12,
				device: 'desktop',
				id: id()
			}
		]
	}
};
